import { CaptchaWidget } from './CaptchaWidget';

export default CaptchaWidget;
